<template>
  <div>
    <PageHeader
      :page="page"
      :has-return="false"
      :left-side-class="'col-xl-8'"
      :right-side-class="
        'col-xl-4 align-items-end d-flex pb-2 justify-content-end'
      "
    >
      <template v-slot:customActions>
        <ActionButton
          i="fas fa-arrow-circle-left"
          variant="ab-btn  ab-btn-outline-success m-1"
          @click="onReturn"
        >
          Regresar
        </ActionButton>

        <ActionButton
          i="fas fa-file-plus"
          variant="success m-1"
          @click="onAddNewRequest"
        >
          Añadir
        </ActionButton>
      </template>
    </PageHeader>

    <div class="row bg-light-gray">
      <div class="col-12 col-md-5">
        <FilterManager
          ref="filterManager"
          v-model="filters"
          :filters="filtersHeader"
          :display-advanced="false"
          @search="onSearch"
        />
      </div>
    </div>

    <template v-if="showNotResults">
      <CustomResultNotFound
        class="mt-4 row pt-3"
        text="No cuenta con solicitudes en sistema."
      />
    </template>

    <template v-else>
      <CustomSeparator
        text="Resultado de Consultas"
        class="my-4 custom-separator-line"
      />

      <template v-for="(item, i) in result.data">
        <ResultRow :key="i" :value="item" @onRowDeleted="onRowDeleted" />
      </template>

      <template v-if="pagination.totalItemCount > pagination.perPage">
        <Pagination
          :data="pagination"
          :page-size="pagination.perPage"
          @pagination-go-page="onPageChange"
        />
      </template>
    </template>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import ActionButton from 'ActionButton';
import ResultRow from './components/ResultRow.vue';
import CustomResultNotFound from 'custom-result-not-found';
import FilterManager from 'FilterManager';
import Pagination from 'pagination';
import CustomSeparator from 'custom-separator';

import academicYearService from '@/services/academicyear';
import { getTapRequestHistory } from '@/services/api/tapRequest.api.js';
import alert from '@/mixin/alert.mixin';

import store from '@/store/index';
import StudentStatuses from '@/utils/constants/student/studentStatuses';

export default {
  name: 'UtaHistoryRequests',
  mixins: [alert],
  components: {
    PageHeader,
    ActionButton,
    ResultRow,
    CustomResultNotFound,
    FilterManager,
    Pagination,
    CustomSeparator,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-edit',
        title: 'Historial de Consulta',
        routes: [
          'Inicio',
          'Solicitud de Asistencia Técnica de Ubicación del Estudiante',
        ],
      },
      collections: {
        academicYears: [],
      },
      filters: {
        academicYear: null,
      },
      result: {
        data: [],
        pagination: {
          perPage: 10,
          currentPage: 1,
          totalItemCount: 0,
          pageCount: 0,
          count: 0,
        },
      },
    };
  },
  computed: {
    showNotResults() {
      return this.result.data.length == 0;
    },
    filtersHeader() {
      return [
        {
          name: 'academicYear',
          component: 'CustomDropDown',
          options: this.collections.academicYears,
          value: this.filters.academicYear,
          placeholder: 'Seleccione el año',
          fieldName: 'description',
          fieldKey: 'id',
          clearable: false,
          class: 'col-sm-12 ml-0 mr-0',
          classContainer: 'w-100',
          validations: 'required',
          mapParentValue: this.filters.academicYear == null,
          error: 'El año académico es requerido.',
        },
      ];
    },
    pagination() {
      return this.result.pagination;
    },
  },
  methods: {
    onReturn() {
      this.$router.go(-1);
    },
    async onRowDeleted() {
      await this.onSearch();
    },
    async onSearch() {
      await this.fetchResults();
    },
    async onPageChangeHandler(page) {
      await this.fetchResults(page);
    },
    async fetchAcademicYears() {
      const {
        data: academicYearsList,
      } = await academicYearService.getAcademicYearFromIntoType();

      this.collections.academicYears = academicYearsList;
      this.filters.academicYear = academicYearsList.find((e) => e.selected);
    },
    async fetchResults(pageIndex = 1) {
      this.result.data = [];

      const params = {
        studentSieId: this.$store.getters.SelectedStudent.studentId,
        academicYearId: this.filters.academicYear.id,
        pageIndex: pageIndex,
        pageSize: 10,
      };

      const { data: response } = await getTapRequestHistory(params);

      this.result = {
        data: response.data,
        pagination: {
          currentPage: response.currentPage,
          totalItemCount: response.totalItemCount,
          pageCount: response.pageCount,
          count: response.count,
          perPage: 10,
        },
      };
    },
    async fetchResources() {
      await this.fetchAcademicYears();
    },
    async onAddNewRequest() {
      if (
        store.getters.SelectedStudent.statusId !== StudentStatuses.Servido &&
        store.getters.SelectedStudent.statusId !== StudentStatuses.Elegible
      ) {
        alert.methods.ShowToast(
          'Alerta',
          'Para realizar el proceso de solicitud de asistencia técnica de ubicación del estudiante, el estatus del estudiante debe ser Elegible o Servido.',
          'error',
          null
        );
        return false;
      }
      this.$router.push({
        name: 'uta-request',
      });
    },
  },
  async mounted() {
    await this.fetchResources();
    await this.fetchResults();
  },
};
</script>
